import AccountInfo from "./AccountInfo";

export default AccountInfo;
